import { pumpTradeModel } from '@models/pump-trade.model';
import dayjs from 'dayjs';
import { OpenapiClientPump } from 'foca-openapi';
import { useEffect, useState } from 'react';

export const usePumpTradePresent = () => {
  const [lastTime, setLastTime] = useState(Date.now()); //1746767096855
  const [present, setPresent] = useState<OpenapiClientPump.GetTradePresentResponse>([]);

  const [newPresent, setNewPresent] = useState<OpenapiClientPump.GetTradePresentResponse>([]);

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;
    const loop = async () => {
      const result = await pumpTradeModel.fetchTradePresent();
      setPresent(result);

      timer = setTimeout(() => {
        loop();
      }, 1000 * 3);
    };
    loop();
    return () => {
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    if (present.length > 0) {
      let max_timestamp = lastTime;

      const res = present.filter((item) => {
        const time = dayjs(item.timestamp).valueOf();
        if (time > lastTime) {
          max_timestamp = time;
        }
        return time > lastTime;
      });

      setNewPresent(res);
      setLastTime((pre) => {
        return max_timestamp > pre ? max_timestamp : pre;
      });
      setPresent([]);
    }
  }, [JSON.stringify(present), lastTime]);

  return newPresent;
};
